import { TimeOfDayEnrollmentStatus } from '../../__generated__/pge-types';

export const isTimeOfDayEnrolled = (status?: TimeOfDayEnrollmentStatus) =>
  status === TimeOfDayEnrollmentStatus.Enrolled ||
  status === TimeOfDayEnrollmentStatus.PendingEnrolled ||
  status === TimeOfDayEnrollmentStatus.PendingUnenrolled;
